import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import ja from 'vuetify/es5/locale/ja.js'

Vue.use(Vuetify)

export default new Vuetify({
  lang: {
    locales: { ja },
    current: 'ja'
  },
  theme: {
    themes: {
      light: {
        primary: '#2D71BF',
        secondary: '#b0bec5',
        maintitle: '#ffffff',
        subtitle1: '#000080',
        accent: '#8c9eff',
        error: '#b71c1c'
      }
    }
  }
})
